module.exports = __webpack_public_path__ + "assets/media/drift-logo.8dacb206.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/Deal/drift-logo.svg
// module id = 1054
// module chunks = 0